module.exports = __webpack_public_path__ + "src/routes/customChart/WordCloud/logo.png?2afc782f";


//////////////////
// WEBPACK FOOTER
// ./src/routes/customChart/WordCloud/logo.png
// module id = 2839
// module chunks = 1